import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";
import get from "lodash/get";
import PageNotFound from "../../../../../Component/NotFound/index";
import PayrollDetails from "./Details";
import FlexiblePlan from "./FlexiblePlan";
import MoreOptions from "./MoreOptions";
import PayrollConfig from "./PayrollConfig";
import SalaryComponent from "./SalaryComponent";
import SalaryCycle from "./SalaryCycle";
import SalaryStructure from "./SalaryStructure";
import Tags from "./Tags";
import PayrollFnf from "./PayrollFnf";
import ExtratimePaymentPolicy from "./ExtratimePaymentPolicy";
import { instance } from "../../../../../Actions/AxiosInstance";
import { ErrorMessages } from "../../../../../Constants";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

const PAYROLL_CONFIG_CONST = {
  salaryassignedtypeid: null, // 2,
  payrolltypeid: null, // 1,
  roundofftypeid: null, // 2,
  islwfdeduction: null, // false,
  isptdeduction: null, // true,
  isfbp: null, // false,
  isseparatebusinessentity: null, // false
};

class index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isseparatebusinessentity: false,
      payrollconfigdata: PAYROLL_CONFIG_CONST,
      datareceived: false,
    };
    this.getpayrollconfig = this.getpayrollconfig.bind(this);
  }

  componentDidMount() {
    this.getpayrollconfig();
  }

  getpayrollconfig() {
    instance
      .get("payroll/payrollconfig")
      .then((resp) => {
        const { history } = this.props;
        const data = get(resp, "data.result[0]", PAYROLL_CONFIG_CONST);
        if (
          !history.location.pathname.includes("payroll/method") &&
          (!get(resp, "data.result[0]", "") ||
            (!data.salaryassignedtypeid && !data.payrolltypeid))
        ) {
          this.props.enqueueSnackbar(ErrorMessages.E1410, { variant: "error" });
          window.open("./method", "_self");
          // this.props.history.push("./config");
          // return;
        }
        this.setState({
          isseparatebusinessentity: data.isseparatebusinessentity,
          payrollconfigdata: data,
          datareceived: true,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
        this.setState({ datareceived: true });
      });
  }

  render() {
    const goTo = (path) => {
      this.props.history.push(path);
    };
    const { match } = this.props;
    const { payrollconfigdata, datareceived } = this.state;

    return (
      datareceived && (
        <Switch>
          {/* <Route path={`${match.path}/payrollcomponentform/:salarycomponentid`} render={(props) => <PayrollComponentForm {...props} goTo={goTo} />} />
        <Route path={`${match.path}/payrollcomponentform`} render={(props) => <PayrollComponentForm {...props} goTo={goTo} />} /> */}
          {/* <Route path={`${match.path}/payrollcomponentlist`} render={(props) => <PayrollComponentList {...props} goTo={goTo} />} /> */}

          <Route
            path={`${match.path}/payroll/details`}
            render={(props) => (
              <PayrollDetails
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
              />
            )}
          />
          <Route
            path={`${match.path}/payroll/fnf`}
            render={(props) => (
              <PayrollFnf
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
              />
            )}
          />
          <Route
            path={`${match.path}/payroll/salary_cycle`}
            render={(props) => (
              <SalaryCycle
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
              />
            )}
          />
          <Route
            path={`${match.path}/payroll/salary_structure`}
            render={(props) => (
              <SalaryStructure
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
              />
            )}
          />
          <Route
            path={`${match.path}/payroll/tag`}
            render={(props) => (
              <Tags
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
              />
            )}
          />
          <Route
            path={`${match.path}/payroll/salary_component`}
            render={(props) => (
              <SalaryComponent
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
              />
            )}
          />
          <Route
            path={`${match.path}/payroll/fbp`}
            render={(props) => (
              <FlexiblePlan
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
              />
            )}
          />
          <Route
            path={`${match.path}/payroll/misc`}
            render={(props) => (
              <MoreOptions
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
                activeTabValue={0}
              />
            )}
          />
          <Route
            path={`${match.path}/payroll/misc/rounding`}
            render={(props) => (
              <MoreOptions
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
                activeTabValue={0}
              />
            )}
          />
          {/* <Route
            path={`${match.path}/lwfbenefits`}
            render={(props) => (
              <MoreOptions {...props} goTo={goTo} payrollconfigdata={payrollconfigdata} getpayrollconfig={this.getpayrollconfig} activeTabValue={1} />
            )}
          /> */}
          <Route
            path={`${match.path}/payroll/misc/variable`}
            render={(props) => (
              <MoreOptions
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
                activeTabValue={1}
              />
            )}
          />
          <Route
            path={`${match.path}/payroll/misc/fbp`}
            render={(props) => (
              <MoreOptions
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
                activeTabValue={2}
              />
            )}
          />
          <Route
            path={`${match.path}/payroll/misc/salary_slip`}
            render={(props) => (
              <MoreOptions
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
                activeTabValue={3}
              />
            )}
          />
          <Route
            path={`${match.path}/payroll/misc/loan`}
            render={(props) => (
              <MoreOptions
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
                activeTabValue={4}
              />
            )}
          />
          <Route
            path={`${match.path}/payroll/misc/declaration`}
            render={(props) => (
              <MoreOptions
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
                activeTabValue={5}
              />
            )}
          />
          <Route
            path={`${match.path}/payroll/misc/submission`}
            render={(props) => (
              <MoreOptions
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
                activeTabValue={6}
              />
            )}
          />
          <Route
            path={`${match.path}/payroll/method`}
            render={(props) => (
              <PayrollConfig
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
              />
            )}
          />
          <Route
            path={`${match.path}/payroll/overtimepaymentpolicy`}
            render={(props) => (
              <ExtratimePaymentPolicy
                {...props}
                goTo={goTo}
                payrollconfigdata={payrollconfigdata}
                getpayrollconfig={this.getpayrollconfig}
              />
            )}
          />
          <Route path="*" component={PageNotFound} />
        </Switch>
      )
    );
  }
}

// const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  null,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(index)));
